export function workerFunction() {
    self.addEventListener("message", () => {
        fetch(`${process.env.API_END_POINT}/services-status`)
            .then((resp) => resp.json())
            .then((data) => self.postMessage({ data }));
    });
}
